/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import guidebookContentStyle from "../guidebookContentStyle";
import TextContainer from "../../Container/TextContainer";
import Layout from "../../../containers/Layouts/Layout";
import TeaserSlogan from "../../Teaser/TeaserSlogan";
import QuestionsContactSection from "../QuestionsContactSection/QuestionsContactSection";
import DoubleButton from "../../Button/DoubleButton";
import { Helmet } from "react-helmet-async";
import backgroundTeaser from "../../../assets/img/guidebook/Teaser_Verfahrenskostenhilfe_700px.jpg";
import Typography from "@mui/material/Typography";
import { Paper } from "@mui/material";
import { gaSet } from "../../../services/googleAnalyticsService";

const GuidebookDivorceProcessCostSupport = () => {
  const title = "Ratgeber - Verfahrenskostenhilfe | Legalbird";

  gaSet({ title: title });

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>{title}</title>
        <meta
          name="description"
          content="In Deutschland gibt es die Verfahrenskostenhilfe, um geringer Verdienende bei Rechtsangelegenheiten finanziell
            zu unterstützen. Wie das funktioniert, erfahren Sie hier."
        />
      </Helmet>

      <Paper sx={guidebookContentStyle.paper}>
        <TeaserSlogan
          slogan={"Einfach erklärt: Verfahrenskostenhilfe"}
          backgroundImagePath={backgroundTeaser}
          height={300}
          headingColor={"#333333"}
        />
        <TextContainer>
          <p>
            Sie haben ein sehr geringes Einkommen und sind daher nicht sicher, ob Sie die Scheidung bezahlen können? In Deutschland gibt es die
            Verfahrenskostenhilfe, um geringer Verdienende bei Rechtsangelegenheiten finanziell zu unterstützen. Wie das funktioniert, erfahren Sie hier.
          </p>
          <hr />
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Was ist Verfahrenskostenhilfe?
          </Typography>
          <p>
            Bei der Verfahrenskostenhilfe übernimmt der Staat die Gerichtskosten für Personen, die ein gerichtliches Verfahren selbst nicht bezahlen können.
            Hierzu muss ein Antrag auf Verfahrenskostenhilfe gestellt werden. Wird dieser Antrag bewilligt, ist die Durchführung des Scheidungsverfahrens für
            Sie entweder komplett kostenlos oder der Staat leiht Ihnen das Geld und Sie können es in kleinen Raten zurück zahlen.
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Kommt die Verfahrenskostenhilfe für mich in Frage?
          </Typography>
          <p>
            Bei geringem Einkommen oder hohen Schulden, können Sie Verfahrenskostenhilfe (Prozesskostenhilfe) beantragen. Ob der Staat die Kosten übernimmt,
            hängt von der Höhe des Einkommens ab. Wenn Sie Sozialhilfe oder ALG2 (sogenanntes „Hartz 4“) erhalten, müssen Sie normalerweise nichts bezahlen.
          </p>
          <p>
            Die Berechnung, ob Sie Verfahrenskostenhilfe erhalten, basiert darauf, wie viel Geld Sie monatlich zur freien Verfügung haben. Daher müssen Sie in
            dem Formular zum Beantragen der Verfahrenskostenhilfe genau darlegen, welche Einnahmen und Ausgaben Sie pro Monat haben. Je nachdem, wie viel Geld
            Ihnen zur Verfügung steht, wird die Verfahrenskostenhilfe entweder mit Rückzahlung per Ratenzahlung oder ohne Rückzahlung gewährt. Bei der
            Verfahrenskostenhilfe mit Ratenzahlung handelt es sich um ein sogenanntes Justizdarlehen, das Sie in sehr kleinen Raten zurückzahlen müssen.
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Antrag auf Verfahrenskostenhilfe stellen
          </Typography>
          <p>
            Sobald Sie den Scheidungsantrag bei uns fertig ausgefüllt haben, erhalten Sie per E-Mail das benötigte Formular und weitere Hinweise zur
            Verfahrenskostenhilfe. Gerne helfen wir Ihnen auch beim Ausfüllen des Formulars.
          </p>
          <DoubleButton buttonText={"zum Scheidungsantrag"} buttonLink={"/servicewelt"} backText={"Zurück zum Ratgeber"} backLink={"/ratgeber/familienrecht"} />
          <QuestionsContactSection />
        </TextContainer>
      </Paper>
    </Layout>
  );
};

export default GuidebookDivorceProcessCostSupport;
